import React from 'react'

import { withStyles } from '@material-ui/core/styles'
import SvgIcon from '@material-ui/core/SvgIcon'
import PropTypes from 'prop-types'

const styles = theme => ({})

// First try to find in the material-ui core icons here: https://material.io/tools/icons/?style=baseline
// Second try to get it from here which are compatable with code below: https://materialdesignicons.com/
// If you can't find it at materialdesignicons.com, try to convert it.
//  Resize to 24x24: https://www.iloveimg.com/resize-image/resize-svg (inkscape didn't work)
//  Optimise path here: http://petercollingridge.appspot.com/svg-optimiser
function IconAboutDomain (props) {
  const { classes, htmlColor, iconSizeEnum } = props
  return (
    <div className={classes.root}>
      <SvgIcon className={classes.icon} htmlColor={htmlColor} fontSize={iconSizeEnum}>
        <path d="M18,15H16V17H18M18,11H16V13H18M20,19H12V17H14V15H12V13H14V11H12V9H20M10,7H8V5H10M10,11H8V9H10M10,15H8V13H10M10,19H8V17H10M6,7H4V5H6M6,11H4V9H6M6,15H4V13H6M6,19H4V17H6M12,7V3H2V21H22V7H12Z" />
      </SvgIcon>
    </div>
  )
}
// <path style=" stroke:none;fill-rule:nonzero;fill:rgb(0%,0%,0%);fill-opacity:1;" d="M 20.191406 4.957031 C 20.324219 5.277344 20.269531 5.550781 20.027344 5.777344 L 14.25 11.554688 L 14.25 20.25 C 14.25 20.578125 14.097656 20.808594 13.792969 20.941406 C 13.691406 20.980469 13.59375 21 13.5 21 C 13.289062 21 13.113281 20.925781 12.972656 20.777344 L 9.972656 17.777344 C 9.824219 17.628906 9.75 17.453125 9.75 17.25 L 9.75 11.554688 L 3.972656 5.777344 C 3.730469 5.550781 3.675781 5.277344 3.808594 4.957031 C 3.941406 4.652344 4.171875 4.5 4.5 4.5 L 19.5 4.5 C 19.828125 4.5 20.058594 4.652344 20.191406 4.957031 Z M 20.191406 4.957031 "/>
IconAboutDomain.propTypes = {
  classes: PropTypes.object.isRequired,
  htmlColor: PropTypes.string,
  iconSizeEnum: PropTypes.string
}

export default withStyles(styles)(IconAboutDomain)
